import { useContext } from 'react';
import { Typography, Drawer, List, ListItem, Theme, Divider, Grid, ListItemButton } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Link as RouterLink } from 'react-router-dom';
import { appUserContext } from 'helpers/services';
import UserMenu from './UserMenu';
import LocaleMenu from './LocaleMenu';
import AdminMenu from './AdminMenu';
import { MdChecklist as TicketIcon, MdOutlineMoveToInbox as InboxIcon, MdSchedule as AbsenceIcon } from 'react-icons/md';
import { AiOutlineSchedule as SchedulingIcon } from 'react-icons/ai'
import { IoPeople as CustomerIcon } from 'react-icons/io5'
import { useIntl } from 'react-intl';
import { LocalizationIds } from 'helpers/Localizations';
import theme from 'assets';


interface ISidebarProps {
    sidebarOpen: boolean

    closeSidebar: () => void
}

let useStyles = makeStyles()((theme: Theme) => ({
    menuHeader: {
        paddingTop: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    }
}));

let Sidebar = ({ sidebarOpen, closeSidebar }: ISidebarProps) => {
    let { formatMessage } = useIntl();
    let { classes } = useStyles();

    let appUserService = useContext(appUserContext);


    return (
        <Drawer
            anchor="left"
            onClose={closeSidebar}
            open={sidebarOpen}
            variant="temporary"
        >
            <Grid container>
                <Grid item xs={12} className={classes.menuHeader}>
                    <Typography>MENU</Typography>
                </Grid>
                <Grid item xs={12} style={{ paddingLeft: theme.spacing(2) }}>
                    {appUserService.isAuthorized === true &&
                        <List>
                            <ListItemButton
                                color="inherit"
                                component={RouterLink}
                                to="/tickets"
                                onClick={closeSidebar}
                            >
                                <TicketIcon />&nbsp;Tickets
                            </ListItemButton>

                            {appUserService.currentUser?.simecClaims?.canManageTicketInbox &&
                                <ListItemButton
                                    color="inherit"
                                    component={RouterLink}
                                    to="/tickets/inbox"
                                    onClick={closeSidebar}
                                >
                                    <InboxIcon />&nbsp;Inbox
                                </ListItemButton>
                            }

                            {(appUserService.currentUser?.simecClaims?.canViewScheduling === true
                                || appUserService.currentUser?.simecClaims?.canEditScheduling === true
                            ) &&
                                <>
                                    <ListItemButton
                                        color="inherit"
                                        component={RouterLink}
                                        to="/scheduling"
                                        onClick={closeSidebar}
                                    >
                                        <SchedulingIcon />&nbsp;{formatMessage({ id: LocalizationIds.Scheduling })}
                                    </ListItemButton>
                                    <ListItemButton
                                        color="inherit"
                                        component={RouterLink}
                                        to="/absences"
                                        onClick={closeSidebar}
                                    >
                                        <AbsenceIcon />&nbsp;{formatMessage({ id: LocalizationIds.Absence })}
                                    </ListItemButton>
                                </>
                            }

                            <ListItemButton
                                color="inherit"
                                component={RouterLink}
                                to="/tools"
                                onClick={closeSidebar}
                            >
                                <InboxIcon />&nbsp;Strumenti
                            </ListItemButton>

                            {appUserService.currentUser?.simecClaims?.canManageCustomerUsers === true &&
                                <ListItemButton
                                    color="inherit"
                                    component={RouterLink}
                                    to="/customers"
                                    onClick={closeSidebar}
                                >
                                    <CustomerIcon />&nbsp;Clienti
                                </ListItemButton>
                            }
                        </List>
                    }

                    <Divider variant="fullWidth" />
                    <ListItem disableGutters>
                        <LocaleMenu />
                    </ListItem>
                    <Divider variant="fullWidth" />
                </Grid>

                <Grid container style={{ padding: 0 }}>
                    <Grid item xs />
                    <Grid item>
                        <UserMenu />
                    </Grid>
                    {(
                        appUserService.currentUser?.simecClaims?.canManageSimecUsers === true
                        || appUserService.currentUser?.simecClaims?.canManageTicketCategories === true
                        || appUserService.currentUser?.simecClaims?.canManageToolTypologies === true
                        || appUserService.currentUser?.simecClaims?.canManageCanGoToCustomerSimecUsers === true
                    ) && appUserService.isAuthorized &&
                        <Grid item>
                            <AdminMenu />
                        </Grid>
                    }
                    <Grid item xs />
                </Grid>
            </Grid>
        </Drawer>
    )
}

export default Sidebar;